import { Box, Card, H1, Text } from '@betterment/samba-react';

import womanLiftingTasks from './images/woman_lifting_tasks.svg';

import { ApplicationLayout } from '../layout/ApplicationLayout';

export const TasksPage = () => {
  return (
    <ApplicationLayout pageTitle="Tasks">
      <ApplicationLayout.Header>
        <Box css={{ maxWidth: '760px', mx: 'auto', width: '100%' }}>
          <H1 variant="title300">Tasks</H1>
        </Box>
      </ApplicationLayout.Header>

      {/*
      This is naively assuming we will always have an empty state
      We will make this dynamic later on in this project
      */}
      <ApplicationLayout.Content>
        <Card
          css={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            p: 'space.300',
            maxWidth: '760px',
            mx: 'auto',
          }}
        >
          <img src={womanLiftingTasks} alt="" />
          <Text css={{ marginTop: 'space.400' }}>You're all caught up!</Text>
        </Card>
      </ApplicationLayout.Content>
      <ApplicationLayout.Footer />
    </ApplicationLayout>
  );
};
